export default {
  extraSmall: 10,
  small: 12,
  medium: 14,
  mediumLarge: 16,
  large: 18,
  extraLarge: 20,
  extraExtraLarge: 24,
}
